import {Component, input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {Subscription} from "rxjs";
import {DjangoApiService} from "../../../../shared/services/django-api.service";
import {LanguageService} from "../../../../shared/services/language.service";
import {LangChangeEvent, TranslateService} from "@ngx-translate/core";
import {CardsBasicComponent} from "../../../../shared/components/cards/cards-basic/cards-basic.component";
import {SectionDetailComponent} from "../section-detail/section-detail.component";
import {PdfService} from "../../../../shared/services/pdfMake/pdf.service";
import {StatisticListComponent} from "../statistic-list/statistic-list.component";

@Component({
  selector: 'app-section-list',
  standalone: true,
  imports: [
    CardsBasicComponent,
    SectionDetailComponent,
    StatisticListComponent
  ],
  templateUrl: './section-list.component.html',
  styleUrl: './section-list.component.css'
})
export class SectionListComponent implements OnInit, OnDestroy, OnChanges {
  pageId = input<any>();
  selectedPeriod = input<any>();
  selectedBenchmark = input<any>();

  sections!: any;

  currentLanguage!: string;
  langChangeSubscription: Subscription | null = null;
  private subscriptions: Subscription = new Subscription();

  constructor(
    private _apiService: DjangoApiService,
    private _languageService: LanguageService,
    private _translate: TranslateService,
    private _pdfService: PdfService,) {
  }

  ngOnInit(): void {
    this.loadSectionList();
    this.setLanguageSubscription()
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['pageId'] && !changes['pageId'].firstChange) {
      if (changes['pageId'].currentValue !== changes['pageId'].previousValue) {
        this.loadSectionList();
      }
    }
  }


  private setLanguageSubscription(): void {
    this.currentLanguage = this._languageService.getLanguage();
    this._pdfService.initializeCurrentLanguage(this.currentLanguage)
    this.subscriptions.add(
      this.langChangeSubscription = this._translate.onLangChange
        .subscribe((event: LangChangeEvent) => {
          this.currentLanguage = event.lang;
          this._pdfService.initializeCurrentLanguage(this.currentLanguage)
        })
    );
  }

  loadSectionList() {
    this.subscriptions.add(
      this._apiService.fetchSectionList(this.pageId()).subscribe({
        next: (response: any) => {
          this.sections = response;
          console.log('Section List Component', this.sections);
          this._pdfService.initializeDataSource(this.sections)
        },
        error: (error: any) => {
          console.log(error);
        }
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe()
  }

}
